import Charts from './components/Charts.vue'
import ChartsSsrn from './components/ChartsSsrn.vue'
import ChartsArxiv from './components/ChartsArxiv.vue'
import Acm from './components/Acm.vue'
import ChartsTotal from './components/ChartsTotal.vue'
import Trending from './components/Trending_multilang.vue'
import Social from './components/Social_multilang.vue'
import Technology from './components/Technology_multilang.vue'
import Technology_old from './components/Technology.vue'
import Visualizations from './components/Visualizations.vue'

export default [
    {title: 'Visualizations',
    path: '/Visualizations',
    component: Visualizations,
    show_navbar: false,
    show_navbar2: false},
    {title: 'Media',
    path: '/',
    component: Charts,
    show_navbar: true,
    show_navbar2: false},
    {title: 'SSRN',
    path: '/ChartsSsrn',
    component: ChartsSsrn,
    show_navbar: true,
    show_navbar2: false},
    {title: 'arXiv',
    path: '/ChartsArxiv',
    component: ChartsArxiv,
    show_navbar: true,
    show_navbar2: false},
    {title: 'ACM',
    path: '/Acm',
    component: Acm,
    show_navbar: true,
    show_navbar2: false},
    {title: 'Common terms',
    path: '/ChartsTotal',
    component: ChartsTotal,
    show_navbar: true,
    show_navbar2: false},
    {title: 'Trending',
    path: '/Trending',
    component: Trending,
    show_navbar: false,
    show_navbar2: true},
    {title: 'Social issues',
    path: '/Social',
    component: Social,
    show_navbar: false,
    show_navbar2: true},
    {title: 'Technology',
    path: '/Technology',
    component: Technology,
    show_navbar: false,
    show_navbar2: true},
]


// WEBPACK FOOTER //
// ./src/routes.js